import { FC } from 'react';
import ServiceList from './ServiceList';
import UseServiceList from './UseServiceList';

const ServiceListContainer: FC = () => {
  return <ServiceList {...UseServiceList()} />;
};

export default ServiceListContainer;
